import script from "./AdminLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLogin.vue?vue&type=script&setup=true&lang=js"

import "./AdminLogin.vue?vue&type=style&index=0&id=174336fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174336fa"]])

export default __exports__